export const es = {
    title: `Editar perfil`,
    updated: `¡Perfil actualizado con éxito!`,
    save: `Guardar cambios`,
    saving: `Guardando...`,
    failure: `Actualización de perfil fallida`,
};
//# sourceMappingURL=es.js.map